import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { SocCodeLookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-soc-code-picker',
  standalone: true,
  imports: [FormsModule, AutoCompleteModule],
  templateUrl: './soc-code-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SOCCodePickerComponent),
      multi: true,
    },
  ],
})
export class SOCCodePickerComponent extends BasePickerComponent<SocCodeLookupItem> {
  override suggestions: SocCodeLookupItem[] = [];
  @Input() searchMode: boolean = false;
  @Input() readonly: boolean = false;
  @Output() itemSelected = new EventEmitter<SocCodeLookupItem>();

  override getItemLabelProperty = () => 'displayName';

  value: string = '';

  onKeyDown(event: KeyboardEvent): void {
    // Method kept for backward compatibility
  }

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<SocCodeLookupItem>> {
    return this.lookupService.getSOCCodes(undefined, query, 20).pipe(
      map((result) => ({
        ...result,
        items: result.items.map((item) => ({
          ...item,
          displayName: `${item.code} – ${item.title}`,
        })),
      }))
    );
  }

  override load(keys: string[]): Observable<ListResult<SocCodeLookupItem>> {
    return this.lookupService.getSOCCodes(keys).pipe(
      map((result) => ({
        ...result,
        items: result.items.map((item) => ({
          ...item,
          displayName: `${item.code} – ${item.title}`,
        })),
      }))
    );
  }

  override handleChange(event: any): void {
    this.onTouched();
    this.onChange(undefined);
  }

  override writeValue(value: any): void {
    this.value = value;
  }

  onSelected(event: AutoCompleteSelectEvent): void {
    this.onTouched();
    this.onChange(event.value);
    if (this.searchMode) {
      this.itemSelected.emit(event.value);
      this.selected = undefined;
      this.suggestions = [];
    }
  }

  public clear() {
    this.value = '';
  }
}
